export const MEDIA_BASE_URL_STAGING = 'https://media.staging.atl-paas.net';
